/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Logo
 */
export interface Logo {
    /**
     * 
     * @type {string}
     * @memberof Logo
     */
    hash?: string;
    /**
     * 
     * @type {string}
     * @memberof Logo
     */
    uri?: string;
}

/**
 * Check if a given object implements the Logo interface.
 */
export function instanceOfLogo(value: object): boolean {
    return true;
}

export function LogoFromJSON(json: any): Logo {
    return LogoFromJSONTyped(json, false);
}

export function LogoFromJSONTyped(json: any, ignoreDiscriminator: boolean): Logo {
    if (json == null) {
        return json;
    }
    return {
        
        'hash': json['hash'] == null ? undefined : json['hash'],
        'uri': json['uri'] == null ? undefined : json['uri'],
    };
}

export function LogoToJSON(value?: Logo | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'hash': value['hash'],
        'uri': value['uri'],
    };
}

